var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"FlipClock"},[_c('Flipper',{ref:"flipperHour1"}),_c('Flipper',{ref:"flipperHour2"}),_c('em',[_vm._v(":")]),_c('Flipper',{ref:"flipperMinute1"}),_c('Flipper',{ref:"flipperMinute2"}),_c('em',[_vm._v(":")]),_c('Flipper',{ref:"flipperSecond1"}),_c('Flipper',{ref:"flipperSecond2"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }